export default "__VITE_ASSET__BNVVeAYU__"